(() => {
  const apply = () => {
    const isMobile = window.matchMedia("(max-width:768px)").matches;
    if (!isMobile) return;

    // Ajusta segons alçada real del teu sticky
    const stickyH = 110; // prova 110 / 120 / 130 si cal
    const offset = `${stickyH + 16}px`;

    // Chat (Chatbase/Popupsmart)
    const chat = document.getElementById("chatbase-bubble-button");
    if (chat) {
      chat.style.setProperty("bottom", offset, "important");
      chat.style.setProperty("right", "1rem", "important");
    }

    // Accessibilitat (EqualWeb / Interdeal)
    const a11y = document.getElementById("INDmenu-btn");
    if (a11y) {
      a11y.style.setProperty("top", "auto", "important");
      a11y.style.setProperty("bottom", offset, "important");
      a11y.style.setProperty("left", "1rem", "important"); // opcional: fixa'l a l'esquerra
      a11y.style.setProperty("right", "auto", "important");
    }
  };

  // Aplica en carregar
  window.addEventListener("load", () => {
    apply();

    // Reaplica si els widgets canvien el DOM o els seus styles
    const obs = new MutationObserver(apply);
    obs.observe(document.body, { subtree: true, childList: true, attributes: true });

    window.addEventListener("resize", apply);
  });
})();
